import React, { FunctionComponent } from 'react';
import { BlogAuthor, BlogCategoryContent, BlogRelatedPost } from 'components/Blog/blogTypes';
import useStyles  from './HomeBlog.css';
import RelatedBlogs from 'components/Blog/RelatedBlogs';
import { BlogHomeBanner } from 'components/Blog/BlogHomeBanner';
import FeatureSection from 'components/Home/HomeV2/Components/Sections/FeaturesSection/FeaturesSection';
import { BlogTopCategories } from 'components/Blog/BlogTopCategories';
import LatestStories from 'components/Blog/LatestStories';
import { Link } from '@admitkard/ccl/Link';
import { BlogBreadcrumbs } from 'components/Blog/BlogBreadcrumbs';
import { Icon } from '@admitkard/ccl/Icon';
import BlogAuthorProfile2 from 'components/Blog/BlogAuthorProfile2';
import { AkHead } from 'components/AkHead';
import { ALLOWED_CATEGORY_SLUGS, createSchema } from 'components/Blog/BlogUtils';
import { ff } from '@admitkard/uiutils/featureFlags';

export interface HomeBlogProps {
  posts: BlogRelatedPost[];
  contributors:BlogAuthor[];
  webStories:BlogRelatedPost[];
  categories: BlogCategoryContent[];
}

const HomeBlog: FunctionComponent<HomeBlogProps> = (props) => {
  const classes= useStyles();
  const banner2=false;
  const articlesList = props.posts.map((post) => {
    const postFormatted = { ...post };
    postFormatted.author = (post.author as any).node;
    return postFormatted;
  });
  const latestBlogsList = articlesList?.slice(1,4);
  const olderBlogsList = articlesList?.slice(4);
  function getRandomArrayOfSizeThree(allPost:any) {
    const missedBlogList = [];
    const arrayCopy = [...allPost];
    for (let i = 0; i < 3; i++) {
      const randomIndex = Math.floor(Math.random() * arrayCopy.length);
      missedBlogList.push(arrayCopy[randomIndex]);
      arrayCopy.splice(randomIndex, 1);
    }
    return missedBlogList;
  }

  const filteredCategories = ff.isEnabled('blog-categories-filter')
    ? props.categories?.slice(0, 5)
    : props.categories?.filter((category: any) => {
      return ALLOWED_CATEGORY_SLUGS.includes(category.slug);
    });

  return (
    <>
      <AkHead
        meta={{
          canonical: 'https://www.admitkard.com/blog/',
          robots: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
        }}
        title={'Complete Study Abroad Guide: Where Aspirations Meet Opportunities'}
        description={'Explore Study Abroad opportunities and insights on our blog. Your aspirations, our expertise.'}
      />
      <>
        {createSchema([...props.webStories, ...latestBlogsList, ...olderBlogsList])}
      </>
      <div className={classes.root}>
        <div className={classes.blogHomeContainer}>
          <div className={classes.blogBreadcrumbsContainer}><BlogBreadcrumbs/></div>
          <div className={classes.blogsHomeHeaderSec}>
            <h1 className={classes.blogsHeaderTitle}>AdmitKard Blogs</h1>
            <h2 className={classes.blogsHeaderSubTitle}>Education Without Borders - Study Abroad for a Global Perspective.</h2>
          </div>
          <div className={classes.blogHomeBanner}>
            <Link href={`/blog/${articlesList[0].slug}`} underline="none" className="related-post-link">
              <BlogHomeBanner bannerData={articlesList[0]}/>
            </Link>
          </div>
          <div className={classes.blogsLatestArticle}>
            <div className={classes.headerWebStories}>
              <div className={classes.latestArticlesTitle}>Latest Articles</div>
              <Link className={classes.blogLinkViewAll}
                underline='none' href='/blog/articles'>View All <Icon name='forward' size='xs'/>
              </Link>
            </div>
            {latestBlogsList &&  (
              <RelatedBlogs relatedPost={latestBlogsList} />
            )}
          </div>
          { banner2 && <div className={classes.blogHomeBannerSecond}>
            <BlogHomeBanner imgUrl=''/>
          </div>}
          <div className={classes.blogWebStorySec}>
            <div className={classes.headerWebStories}>
              <div className={classes.webStoriesTitle}>Latest Stories</div>
              <Link className={classes.blogLinkViewAll}
                underline='none' href='/blog/web-stories'>View All <Icon name='forward' size='xs'/>
              </Link>
            </div>
            <LatestStories webStories={props.webStories}/>
          </div>
          <div className={classes.blogTopCategoriesSec}>
            <BlogTopCategories categories={filteredCategories}/>
          </div>
          <div className={classes.blogHomeExploreSec}>
            <div className={classes.exploreSecTitle}>Explore Admitkard</div>
            <FeatureSection/>
          </div>
          <div className={classes.blogsLatestArticle}>
            <div className={classes.missedArticleTitle}>In Case You Missed It</div>
            {latestBlogsList &&  (
              <RelatedBlogs relatedPost={getRandomArrayOfSizeThree(olderBlogsList)} />
            )}
          </div>
          <div className={classes.contributorSection}>
            <div className={classes.contributorSecTitle}>Our Contributors</div>
            <div className={classes.contributorList}>
              {props.contributors.map((contributor:BlogAuthor)=>
                contributor.description && <BlogAuthorProfile2
                  key={contributor?.id}
                  authorName={contributor?.name}
                  authorAvatar={contributor?.avatar?.url}
                  description={contributor?.description}
                  education={contributor?.userCustomFields?.education}
                  experience={contributor?.userCustomFields?.experience}
                  title=''
                  facebookLink={contributor?.userCustomFields?.facebookLink}
                  twitterLink={contributor?.userCustomFields?.twitterLink}
                  linkedinLink={contributor?.userCustomFields?.linkedinLink}
                  openAuthorProfile={true}
                  authorSlug={contributor.slug}
                />)}
            </div>
          </div>
        </div>
      </div>
    </>);
};

export default HomeBlog;
